// extracted by mini-css-extract-plugin
module.exports = {"primaryButtonInverted":"styles_primaryButtonInverted__3N5UZ","secondaryButton":"styles_secondaryButton__3ziKx","primaryButton":"styles_primaryButton__29aHK"};